export const MAPBOX_STATIC_MAP_URL = 'https://api.mapbox.com/styles/v1/mapbox/light-v10/static/'
export const BOT_URL = 'https://botji-api.pinflag.cl'
export const BOT_URL_DEV = 'https://botji-api-stage.pinflag.cl'
export const CMS_ADAPTER_URL = 'https://cms-api.pinflag.cl'
export const CMS_ADAPTER_URL_DEV = 'https://cms-api-stage.pinflag.cl'
export const PAYMENT_BUCKET_URL = 'https://pinmap-payment-methods-assets.s3.sa-east-1.amazonaws.com'
export const COMPANY_API_BASE_URL = 'https://company-api-v2.pinflag.cl'
export const COMPANY_API_BASE_URL_DEV = 'https://company-api-v2-stage.pinflag.cl'
export const API_BASE_URL = 'https://company-api.pinflag.cl/api'
export const API_BASE_URL_DEV = 'https://pinflag-admin-api-dev-4d1b576c28cb.herokuapp.com/api'
export const PINFLAG_CHECKOUT_URL = 'https://checkout-scraper-stage.pinflag.cl'

export const PINFLAG_CHECKOUT_URLS = {
  'sa-east-1': 'https://5mdwq95o2j.execute-api.sa-east-1.amazonaws.com/dev',
  'us-east-1': 'https://checkout-scraper-stage.pinflag.cl',
  'us-east-2': 'https://4d6543uxnl.execute-api.us-east-2.amazonaws.com/dev',
  'us-west-1': 'https://i1nm2exg2i.execute-api.us-west-1.amazonaws.com/dev',
  'us-west-2': 'https://gk67qw0eqk.execute-api.us-west-2.amazonaws.com/dev',
  'pinflag-us': 'https://checkout-scraper-stage.pinflag.cl', // hasta migrar bd
  'pinflag-container': 'https://checkout-scraper-stage.pinflag.cl' // para probar ecs
}

export const PINFLAG_SOCKET_URLS = {
  'sa-east-1': 'wss://9fxmslyqr0.execute-api.sa-east-1.amazonaws.com/production',
  'us-east-1': 'wss://khiv8dzl50.execute-api.us-east-1.amazonaws.com/dev',
  'us-east-2': 'wss://ud9yqqvrbe.execute-api.us-east-2.amazonaws.com/dev',
  'us-west-1': 'wss://51e8b40516.execute-api.us-west-1.amazonaws.com/dev',
  'us-west-2': 'wss://soszfcgoh6.execute-api.us-west-2.amazonaws.com/dev',
  'pinflag-container': 'wss://checkout-scraper-container.pinflag.cl/socket'
}

export const SOCKET_CHECKOUT_URLS = {
  'sa-east-1': 'https://ig2dnc63ogvx33sa7psypror7i0kgfrz.lambda-url.sa-east-1.on.aws',
  'us-east-1': 'https://cbwjyzg7mgumfc7ffhjofuk22e0hhpqw.lambda-url.us-east-1.on.aws',
  'us-east-2': 'https://34iusjbwonbpoune45bq3lfftm0cvsbl.lambda-url.us-east-2.on.aws',
  'us-west-1': 'https://6xhz2m5xew2cx7dsxmpo3p4z5i0bitot.lambda-url.us-west-1.on.aws',
  'us-west-2': 'https://qp35tr6or5jdzz44tr6djy56mq0crzmo.lambda-url.us-west-2.on.aws'
}

export const PROXY_CHECKOUT_URLS = {
  'sa-east-1': 'https://nodlw55ota6gedrfbr2t7rjldm0xfbxx.lambda-url.sa-east-1.on.aws',
  'us-east-1': 'https://2oxwrdmbkacy26k6psk2qt2ehq0ujngb.lambda-url.us-east-1.on.aws',
  'us-east-2': 'https://u3ozju62flrsy7cxgporg23ddm0aqfma.lambda-url.us-east-2.on.aws',
  'us-west-1': 'https://k6hngnvytegcmbmro2daksa4ha0vsxhn.lambda-url.us-west-1.on.aws',
  'us-west-2': 'https://mxscz2hiryshh6aghtihki3wua0zqgvx.lambda-url.us-west-2.on.aws'
}

export const PINFLAG_SOCKET_URL = 'wss://9fxmslyqr0.execute-api.sa-east-1.amazonaws.com/production'
